import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { configureAmplify } from "./helpers/amplifyConfig";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { registerConnectors } from "./startup/registerConnectors";
import { LicenseInfo } from "@mui/x-license";

configureAmplify();
registerConnectors();
LicenseInfo.setLicenseKey(
  "551ac52c51be5b1718979e0561e45491Tz0xMjc2MTMsRT0xODA2NTM3NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=",
);


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
